import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Modal,
  Spinner,
} from "react-bootstrap";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import Swal from "sweetalert2";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { isMobile } from "react-device-detect";
import SelectComponent from "../../../../_Components/ReactSelectComponent";
import HistoryOfTransactionsDesktop from "../../HistoryOfItemForDesktop";
import ApiBasketItemPerson from "../../../../../../core/api/api.basketItemPerson";
import ApiOrderService from "../../../../../../core/api/api.ordersService";
import SwalMessage from "../../../../_Components/SwalMessage";
import MobileView from "../../../../../pages/_Components/MobileView";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { ClockHistory } from "react-bootstrap-icons";

function ModalUpdatePersonInItemsCanceled(props) {
  const [ordersServiceGetItem, setOrderServiceGetItem] = useState();

  const [inputList, setInputList] = useState([]);
  let showPrice = Intl.NumberFormat("en-US");
  const [reasonList, setReasonList] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({ defaultValues: {} });
  const methods = {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
    reset,
  }
  const [showModalChangePerson, setShowModalChangePerson] = useState(true);

  const hederData = [
    { name: "نام" },
    { name: "وضعیت کنسلی" },
    { name: " مبلغ ایتم " },
    { name: "  مبلغ پرداختی" },
    { name: "پرداخت به تامین کننده" },
    { name: "دریافت از تامین کننده " },
    { name: "علت کنسلی" },
  ];

  useEffect(() => {
    (async () => {
      try {
        // دریافت و نمایش علت کنسلی از سرور
        const result = await ApiOrderService.GetEnumsName("BasketCancelType");
        setReasonList(result.data);
        // ------ تنظیم ورودی و دریافت لیست ایتم های کنسلی-----
        let selectedItemSTR = "";
        props.listPersons.forEach((item) => {
          selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
        });
        // ارسال به سرور جهت دریافت جزییات ایتم های انتخابی
        const ordersServiceGetItem = await ApiOrderService.getItemWithDetails({
          basketId: props.basket.basketId,
          listBasketItemPersonID: selectedItemSTR,
        });
        // تکمیل و  مقدار دهی اولیه فیلد های ورودی
        if (ordersServiceGetItem && ordersServiceGetItem.data && ordersServiceGetItem.data.length > 0)
          setInputList(ordersServiceGetItem.data);
        setOrderServiceGetItem(ordersServiceGetItem);
        // ---------
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  let lastService = "";
  function showService(item) {
    if (lastService != item.basketItemAmusementServiceName) {
      lastService = item.basketItemAmusementServiceName;
      return (
        <Row className="mt-5">
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
          <Col xs="auto">
            <h5 className="text-center">{item.basketItemAmusementServiceName}{item.hallEventTitle && ` - ${item.hallEventTitle}`}</h5>{" "}
          </Col>
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
        </Row>
      );
    }
  }

  function inputOnChange(value, inputType, inputItem, changeInGroup) {
    const isLock = inputType + "IsLock";
    // ----  ویرایش ایتم  -----
    inputItem[isLock] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
    inputItem[inputType] = value?.value;
    setValue(inputType + inputItem.id, value);
    // ایا ایتم در اول گروه قرار دارد ؟ تغییر بقیه ایتم ها
    let changeItemList = [];
    if (inputList.length > 0) {
      if (changeInGroup) {
        // اعمال تغییر در گروه خودش تنها صورت پذیرد اگر در ابتدای لیست
        let currentGroupList = inputList.filter(function (item) {
          return item.basketItemId == inputItem.basketItemId;
        });
        if (currentGroupList.length > 0 && currentGroupList[0].id == inputItem.id) changeItemList = currentGroupList;
      } else {
        // اعمال تغییر در تمام لیست صورت پذیرد اگر در ابتدای لیست
        if (inputList[0].id == inputItem.id) changeItemList = inputList;
      }
    }
    // تغییر ایتم های دیگر مجموعه
    if (changeItemList.length > 0) {
      changeItemList.map((item) => {
        if (!item[isLock]) {
          item[inputType] = value?.value;
          setValue(inputType + item.id, value);
        }
      });
    }
  }

  const onSubmit = async (data) => {
    try {
      let result = {
        basketId: parseInt(props.basket.basketId) ? parseInt(props.basket.basketId) : 0,
        listBasketItemPersons: inputList.map((item) => {
          return {
            basketItemPersonId: item.id,
            cancelType: item.cancelType,
          };
        }),
        description: data.description,
      };

      const resApiData = await ApiBasketItemPerson.operatorCanceledBasketItemsPersons(result);
      if (resApiData && resApiData.data) {
        // ساخت و نمایش پیغام خروجی
        let HtmlOutPut = resApiData.data.map((item) => {
          return (
            "<p class='text-md-center ml-6 ml-md-0 my-1'><span>نام آیتم : " +
            item.nameItem +
            " </span><span class='" +
            (item.status == true ? "text-success " : "text-danger") +
            "'> وضعیت کنسلی : " +
            (item.status == true ? "انجام شد" : "انجام نشد") +
            " </span><span> پیغام سیستم : " +
            item.message +
            "</span></p>"
          );
        });
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success  mr-2 px-5 ",
            cancelButton: "btn btn-danger px-5 ",
          },
          buttonsStyling: false,
          willOpen: () => {
            Swal.getPopup().focus()
          },
        });
        swalWithBootstrapButtons.fire({
          title: "عملیات درخواست کنسلی",
          icon: "info",
          html: HtmlOutPut,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: "  بستن ",
        });
        // ویرایش دیتا های روی صفحه پشتی
        props.data.callBack();
        // بستن مدال
        handleClose();
      } else SwalMessage({ title: resApiData.message, iSsuccess: resApiData.succeeded });
    } catch (error) {
    } finally {
    }
  };

  const handleClose = () => {
    setShowModalChangePerson(!showModalChangePerson);
    props.callBack2();
  };

  return (
    <>
      <Modal centered dialogClassName="modal-90w"
        show={showModalChangePerson} onHide={handleClose}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title> عملیات کنسلی اپراتور به درخواست مشتری</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {ordersServiceGetItem && ordersServiceGetItem.succeeded ? (
                isMobile ? (
                  <>
                    <MobileView
                      titles={hederData}
                      data={ordersServiceGetItem}
                      inputOnChange={inputOnChange}
                      control={control}
                      errors={errors}
                      reasonList={reasonList}
                      type="requestOfCancle"
                    />
                  </>
                ) : (
                  <div>
                    <Row>
                      <Col xs="12">
                        {ordersServiceGetItem &&
                          ordersServiceGetItem.data &&
                          ordersServiceGetItem.data.map((item, index) => {
                            return (
                              <div key={index}>
                                {showService(item)}
                                <div>
                                  <Accordion>
                                    <Row className="mt-2 d-flex justify-content-between align-items-center" key={index}>
                                      <Col xs="auto">
                                        <Accordion.Header className="custom-acc-button" variant="link" >
                                          <ClockHistory color="#767885" size={15} />
                                        </Accordion.Header>
                                      </Col>
                                      <Col xs="12" md="3" style={{ maxWidth: 300 }}>
                                        <TextField
                                          disabled
                                          fullWidth
                                          variant="outlined"
                                          label={item.hallBlockName ? "صندلی" : "نام"}
                                          className="mt-5"
                                          value={item.hallBlockName ? `جایگاه: ${item.hallBlockName} - ردیف: ${item.hallRowName} - صندلی: ${item.hallSeatName}` : item.personFullName}
                                        />
                                      </Col>
                                      <Col>
                                        <TextField
                                          disabled
                                          variant="outlined"
                                          label="وضعیت کنسلی"
                                          className="mt-5"
                                          value={item.cancelStatusS}
                                        />
                                      </Col>
                                      <Col>
                                        <TextField
                                          disabled
                                          variant="outlined"
                                          label="مبلغ آیتم"
                                          className="mt-5"
                                          value={`${showPrice.format(item.price)}تومان`}
                                        />
                                      </Col>
                                      <Col>
                                        <TextField
                                          disabled
                                          variant="outlined"
                                          className="mt-5"
                                          label="مبلغ پرداختی"
                                          value={`${showPrice.format(item.paymentAmount)}تومان`}
                                        />
                                      </Col>
                                      <Col>
                                        <TextField
                                          disabled
                                          variant="outlined"
                                          className="mt-5"
                                          label="پرداخت به تامین کننده"
                                          value={`${showPrice.format(item.payToWarantyAmount)}تومان`}
                                        />
                                      </Col>
                                      <Col>
                                        <TextField
                                          disabled
                                          variant="outlined"
                                          className="mt-5"
                                          label="دریافت از تامین کننده"
                                          value={`${showPrice.format(item.receiveOfWarantyAmount)}تومان`}
                                        />
                                      </Col>
                                      <Col lg="auto">
                                        <Controller
                                          name={"cancelType" + item.id}
                                          control={control}
                                          rules={{ required: true }}
                                          render={({ field }) => (
                                            <SelectComponent
                                              className={
                                                errors["cancelType" + item.id]
                                                  ? "border w-250px border-danger mt-5"
                                                  : "w-250px mt-5"
                                              } placeholder="انتخاب وضعیت"
                                              options={reasonList?.map(item => ({ value: item.id, label: item.title }))}
                                              field={field}
                                              onChange={(newValue) => {
                                                inputOnChange(newValue, "cancelType", item, true)
                                                field.onChange(newValue)
                                              }
                                              }
                                            />
                                          )}
                                        />
                                      </Col>
                                    </Row>
                                    <Accordion.Body>
                                      <Card.Body className="px-0">
                                        <HistoryOfTransactionsDesktop
                                          item={item}
                                          itemtransactions={item.transactions}
                                        />
                                      </Card.Body>
                                    </Accordion.Body>
                                  </Accordion>
                                </div>
                              </div>
                            );
                          })}
                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <Controller
                              name="description"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  id="description"
                                  className="w-100 mt-2"
                                  variant="outlined"
                                  type="text"
                                  rows={7}
                                  multiline
                                  placeholder="توضیحات"
                                  value={value}
                                  onInput={onChange}
                                  sx={{
                                    ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                                      padding: "8.5px 14px 8.5px 8.5px !important",
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                )
              ) : (
                <p className="text-center text-large">{ordersServiceGetItem && ordersServiceGetItem.message}</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              {ordersServiceGetItem && ordersServiceGetItem.succeeded && (
                <Button variant="success" disabled={isSubmitting} type="submit">
                  {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                  <SaveIcon className="mr-1" />
                ذخیره
                </Button>
              )}
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon className="mr-1" />
              بستن
            </Button>
            </Modal.Footer>
          </form>

        </FormProvider>
      </Modal>
    </>
  );
}

export default ModalUpdatePersonInItemsCanceled;
